import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputRestriction]'
})
export class InputRestrictionDirective {

  @Input() regex: string = '[^a-zA-Z0-9\\s]';
  constructor(private el:ElementRef, public control: NgControl) { }

  @HostListener('input', ['$event']) onInput(event) {
    const inputValue = event.event.target.value;
    const sanitizedValue = inputValue.replace(new RegExp(this.regex, 'g'), '');
    event.event.target.value = sanitizedValue;
    // event.preventDefault();

    if (this.control.control) {
      this.control.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }

}
